import { Component, input } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, BulletComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { MaintenanceStatus } from '../../services/dto/maintenance-status';

@Component({
  selector: 'cam-maintenance-status',
  templateUrl: './maintenance-status.component.html',
  styleUrls: ['./maintenance-status.component.scss'],
  imports: [BadgeComponent, BulletComponent, TranslatePipe],
})
export class CamMaintenanceStatusComponent extends CamBaseComponent {
  status = input.required<MaintenanceStatus>();

  noLabel = input(false);

  get color(): ColorType {
    switch (this.status()) {
      case MaintenanceStatus.Active:
        return 'success';
      case MaintenanceStatus.Draft:
        return 'purple';
      case MaintenanceStatus.Inactive:
        return 'default';
      case MaintenanceStatus.Cancelled:
        return 'warning';
      case MaintenanceStatus.Terminated:
        return 'secondary';
      default:
        return 'purple';
    }
  }

  get label(): string {
    if (this.noLabel()) {
      return '';
    }

    return `maintenances.status.${MaintenanceStatus[this.status()]?.toLowerCase() ?? 'unknown'}`;
  }
}
